/**
 * 主题配置与切换
 * 朱砂 / 黛青 / 石青 三套只切换主色，宣纸底色与墨色文字保持不变；
 * 「经典蓝」额外覆盖纸色、墨色与边框，用于还原改版前的蓝白灰配色。
 * 所有页面只需引用 CSS 变量即可跟随主题变化。
 */
export const THEME_LIST = [
  { key: 'cinnabar', name: '朱砂红', color: '#A63B32' },
  { key: 'jade', name: '黛青绿', color: '#3F5B52' },
  { key: 'indigo', name: '石青蓝', color: '#2F5F8F' },
  { key: 'classic', name: '经典蓝', color: '#409EFF' }
]

export const THEME_STORAGE_KEY = 'rootandleaf-theme'

// 读取已保存的主题，非法或未设置时回退到朱砂红
export function getStoredTheme() {
  const saved = localStorage.getItem(THEME_STORAGE_KEY)
  return THEME_LIST.some(item => item.key === saved) ? saved : 'cinnabar'
}

// 应用主题：写入 html[data-theme]，全局 CSS 变量随之切换
export function applyTheme(key) {
  const themeKey = THEME_LIST.some(item => item.key === key) ? key : 'cinnabar'
  document.documentElement.setAttribute('data-theme', themeKey)
  localStorage.setItem(THEME_STORAGE_KEY, themeKey)
  return themeKey
}

// 应用启动时调用，避免首屏出现默认色再闪变
export function initTheme() {
  return applyTheme(getStoredTheme())
}

// 读取当前主题某个 CSS 变量的实际色值：供地图标记、弹窗等无法使用 CSS 变量的场景
export function getThemeColor(name, fallback) {
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  return value || fallback
}

// 读取当前主题主色的实际色值
export function getAccentColor() {
  return getThemeColor('--accent', '#A63B32')
}

// 读取金棕辅助色（经典蓝主题下为中性灰）
export function getGoldColor() {
  return getThemeColor('--gold', '#B99A6B')
}
